import React, { useContext, useEffect } from 'react'

import Box, { TBox } from '@components/Box'
import ultraRemConvertor from '@utils/styles/ultraRemConvertor'
import CFormContext from './CFormContext'

export interface ICFormIncludeProps extends TBox {
  children?: React.ReactNode
}

const CFormInclude: React.FC<ICFormIncludeProps> = ({
  children,
  mt,
  mb = 20,
  ml,
  mr,
  mx,
  my,
  pl,
  pt,
  pr,
  pb,
  px,
  py,
  ...boxProps
}) => {
  const context = useContext(CFormContext)

  useEffect(() => {
    if (!context) console.error('CFormInclude component should be inside CForm component')
  }, [context])

  return (
    <Box
      {...{ mb: ultraRemConvertor(mb) }}
      {...{ ml: ultraRemConvertor(ml) }}
      {...{ mr: ultraRemConvertor(mr) }}
      {...{ mt: ultraRemConvertor(mt) }}
      {...{ mt: ultraRemConvertor(mt) }}
      {...{ mx: ultraRemConvertor(mx) }}
      {...{ my: ultraRemConvertor(my) }}
      {...{ pb: ultraRemConvertor(pb) }}
      {...{ pl: ultraRemConvertor(pl) }}
      {...{ pr: ultraRemConvertor(pr) }}
      {...{ pt: ultraRemConvertor(pt) }}
      {...{ px: ultraRemConvertor(px) }}
      {...{ py: ultraRemConvertor(py) }}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

export default CFormInclude
